export const supportedLanguages = ["en", "nl", "de", "dk", "fr", "it", "es"];
export type RmaSupportedLanguage = (typeof supportedLanguages)[number];

export const isSupportedLanguage = (language: string): language is RmaSupportedLanguage =>
  supportedLanguages.includes(language as any);

export interface LanguageSettings {
  additionalLanguages: RmaSupportedLanguage[];
  languageSettingsEnabled: boolean;
}

export interface languageStrings {
  en: string;
  nl: string;
  de: string;
  dk: string;
  fr: string;
  it: string;
  es: string;
}

export type LanguageCode = keyof typeof defaultLanguageStrings;
export const defaultLanguageStrings: languageStrings = {
  en: "English",
  nl: "Dutch",
  de: "German",
  dk: "Danish",
  fr: "French",
  it: "Italian",
  es: "Spanish",
};

// Flag settings
export const languageCodeToCountryCode: Record<string, string> = {
  en: "gb", // English -> UK flag
  us: "us", // English US -> US flag
  nl: "nl", // Dutch -> Netherlands
  de: "de", // German -> Germany
  dk: "dk", // Danish -> Denmark
  fr: "fr", // French -> France
  it: "it", // Italian -> Italy
  es: "es", // Spanish -> Spain
};

export const fallbackLanguageSettings = {
  additionalLanguages: ["en"],
  languageSettingsEnabled: false,
};

export const fallbackLanguage = "en";

export interface LanguageData {
  defaultLanguage: string;
  isDefaultLanguage: boolean;
  selectedLanguageTab: string;
  languageSettingsEnabled: boolean;
}
